import { css } from '@emotion/css';

export const pageBackground = css`
  background: var(--colors-neutrals-20);
`;

export const agreementContainer = css`
  padding: 16px;
  background: var(--colors-neutrals-10);
  margin-bottom: 130px;

  .julo-card.grid {
    padding: 16px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;

    p:nth-of-type(even) {
      text-align: right;
    }
  }

  .julo-card.flex {
    padding: 16px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 10px;

    p {
      flex: 0 0 calc(40% - 5px);
    }

    p:nth-of-type(even) {
      flex: 0 0 calc(60% - 5px);
    }
  }

  .loan-agreement {
    display: flex;
    justify-content: center;

    p {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 24px;
      gap: 4px;
      cursor: pointer;
    }
  }
`;

export const actionButtonContainer = css`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
  background: var(--colors-neutrals-10);
  width: 100%;
  max-width: 550px;
  margin: auto;
  text-align: center;

  p {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding-bottom: 6px;
    margin-bottom: 10px;
    border-bottom: 1px solid var(--colors-neutrals-30);
  }
`;

export const bottomSheetContent = css`
  display: flex;
  flex-direction: column;
  gap: 10px;

  .doc-card {
    display: flex;
    align-items: center;
    gap: 10px;
    border-radius: 8px;
    border: 1px solid var(--colors-neutrals-20);
    padding: 12px;
    cursor: pointer;
  }
`;
